module.exports = __webpack_public_path__ + "7d088296/img/question-icon.06c20c5d.svg";